// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/change_plan.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SubscriptionTier } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/change_plan.proto.
 */
export const file_vision_billing_v1_change_plan: GenFile = /*@__PURE__*/
  fileDesc("CiN2aXNpb24vYmlsbGluZy92MS9jaGFuZ2VfcGxhbi5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxIqsBChFDaGFuZ2VQbGFuUmVxdWVzdBJCCgZwYXJhbXMYASABKAsyMi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2hhbmdlUGxhblJlcXVlc3QuUGFyYW1zGlIKBlBhcmFtcxIQCghwbGFuX2tleRgBIAEoCRI2CgRtb2RlGAIgASgOMigucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlBsYW5DaGFuZ2VNb2RlIpECChJDaGFuZ2VQbGFuUmVzcG9uc2USQwoGcmVzdWx0GAEgASgLMjMucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNoYW5nZVBsYW5SZXNwb25zZS5SZXN1bHQatQEKBlJlc3VsdBI2CgRtb2RlGAEgASgOMigucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlBsYW5DaGFuZ2VNb2RlEj8KC3RhcmdldF90aWVyGAIgASgOMioucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlN1YnNjcmlwdGlvblRpZXISMgoOZWZmZWN0aXZlX2RhdGUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wKm4KDlBsYW5DaGFuZ2VNb2RlEhwKGFBMQU5fQ0hBTkdFX01PREVfVU5LTk9XThAAEh4KGlBMQU5fQ0hBTkdFX01PREVfSU1NRURJQVRFEAESHgoaUExBTl9DSEFOR0VfTU9ERV9TQ0hFRFVMRUQQAmIGcHJvdG8z", [file_vision_billing_v1_vision_billing, file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.billing.v1.ChangePlanRequest
 */
export type ChangePlanRequest = Message<"protos.vision.billing.v1.ChangePlanRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ChangePlanRequest.Params params = 1;
   */
  params?: ChangePlanRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ChangePlanRequest.
 * Use `create(ChangePlanRequestSchema)` to create a new message.
 */
export const ChangePlanRequestSchema: GenMessage<ChangePlanRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_change_plan, 0);

/**
 * @generated from message protos.vision.billing.v1.ChangePlanRequest.Params
 */
export type ChangePlanRequest_Params = Message<"protos.vision.billing.v1.ChangePlanRequest.Params"> & {
  /**
   * @generated from field: string plan_key = 1;
   */
  planKey: string;

  /**
   * @generated from field: protos.vision.billing.v1.PlanChangeMode mode = 2;
   */
  mode: PlanChangeMode;
};

/**
 * Describes the message protos.vision.billing.v1.ChangePlanRequest.Params.
 * Use `create(ChangePlanRequest_ParamsSchema)` to create a new message.
 */
export const ChangePlanRequest_ParamsSchema: GenMessage<ChangePlanRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_change_plan, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.ChangePlanResponse
 */
export type ChangePlanResponse = Message<"protos.vision.billing.v1.ChangePlanResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ChangePlanResponse.Result result = 1;
   */
  result?: ChangePlanResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ChangePlanResponse.
 * Use `create(ChangePlanResponseSchema)` to create a new message.
 */
export const ChangePlanResponseSchema: GenMessage<ChangePlanResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_change_plan, 1);

/**
 * @generated from message protos.vision.billing.v1.ChangePlanResponse.Result
 */
export type ChangePlanResponse_Result = Message<"protos.vision.billing.v1.ChangePlanResponse.Result"> & {
  /**
   * @generated from field: protos.vision.billing.v1.PlanChangeMode mode = 1;
   */
  mode: PlanChangeMode;

  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionTier target_tier = 2;
   */
  targetTier: SubscriptionTier;

  /**
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */
  effectiveDate?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ChangePlanResponse.Result.
 * Use `create(ChangePlanResponse_ResultSchema)` to create a new message.
 */
export const ChangePlanResponse_ResultSchema: GenMessage<ChangePlanResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_change_plan, 1, 0);

/**
 * @generated from enum protos.vision.billing.v1.PlanChangeMode
 */
export enum PlanChangeMode {
  /**
   * @generated from enum value: PLAN_CHANGE_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PLAN_CHANGE_MODE_IMMEDIATE = 1;
   */
  IMMEDIATE = 1,

  /**
   * @generated from enum value: PLAN_CHANGE_MODE_SCHEDULED = 2;
   */
  SCHEDULED = 2,
}

/**
 * Describes the enum protos.vision.billing.v1.PlanChangeMode.
 */
export const PlanChangeModeSchema: GenEnum<PlanChangeMode> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_change_plan, 0);

